<script lang="ts">import { browser } from "$app/environment";
import { page } from "$app/stores";
import { cfgToThemeContentPath } from "@infinitro/config";
import { locale, loggedIn } from "@infinitro/global";
import CdnSeoMarkdownPanel from "./cdn-seo-markdown-panel.svelte";
import { fetchLocaleMarkdownWithEnFallback } from "./fetch-markdown-seo";
export let showMoreButton = true;
let htmlContent = "";
let lastModified = "";
// Adopt the hidden build-time SEO block in place; absent on client navigation → fetch below.
const adopted = (() => {
	if (!browser) return false;
	const block = document.getElementById("seo-static-block");
	if (!block) return false;
	htmlContent = block.querySelector(".markdown-seo")?.innerHTML ?? "";
	block.remove();
	return true;
})();
$: providerSlug = $page.params.provider ?? "";
$: gameSlug = $page.params.game ?? "";
$: if (!adopted) {
	if ($loggedIn === false && providerSlug && gameSlug) {
		const p = providerSlug;
		const g = gameSlug;
		const loc = $locale;
		fetchLocaleMarkdownWithEnFallback(cfgToThemeContentPath(`/seo/games/${p}/${g}/${g}.${loc}.md`), cfgToThemeContentPath(`/seo/games/${p}/${g}/${g}.en.md`)).then(({ html, lastModified: lm }) => {
			if ($loggedIn !== false || p !== $page.params.provider || g !== $page.params.game || loc !== $locale) {
				return;
			}
			htmlContent = html;
			lastModified = lm;
		});
	} else {
		htmlContent = "";
		lastModified = "";
	}
}
</script>

<svelte:head>
	{#if lastModified}
		<meta property="article:modified_time" content={lastModified} />
	{/if}
</svelte:head>

<!-- `!== true`, not `=== false`: loggedIn resolves async; the block is already removed, so a
     crawler snapshotting before it resolves must still see the content. -->
{#if $loggedIn !== true}
	<CdnSeoMarkdownPanel noContainer noTopMargin {htmlContent} {lastModified} {showMoreButton} />
{/if}
